import { toast } from 'react-toastify';
import { apiClient } from './client';
import { extractItemsFromResponse, extractPagedItemsAndTotal, handleApiError } from './utils';

export const confirmDelete = async ({
    apiEndpoint,
    selectedItems,
    toggleModalCallback,
    clearSelectionCallback,
    refreshDataCallback
}) => {
    if (toggleModalCallback) toggleModalCallback();

    try {
        await Promise.all(selectedItems.map(item =>
            apiClient.delete(`${apiEndpoint}/${item.id}`)
        ));

        if (clearSelectionCallback) clearSelectionCallback();
        if (refreshDataCallback) refreshDataCallback();

        toast.success('Seçilen kayıtlar başarıyla silindi!');
    } catch (error) {
        handleApiError(error, 'Kayıtlar silinirken bir hata oluştu.');
    }
};

export const fetchTableData = async ({
    apiEndpoint,
    page,
    pageSize,
    search,
    setDataCallback,
    setTotalRowsCallback,
}) => {
    try {
        const response = await apiClient.get(apiEndpoint, {
            params: { page, pageSize, search },
        });

        let items = [];
        const { rawItems, total } = extractPagedItemsAndTotal(response.data);

        if (!Array.isArray(rawItems)) {
            toast.warn('Veri alınırken beklenmeyen bir yanıt yapısı ile karşılaşıldı.');
            if (setDataCallback) setDataCallback([]);
            if (setTotalRowsCallback) setTotalRowsCallback(0);
            return;
        }

        items = rawItems.map(item => ({
            ...item,
            id: item.id,
        }));

        if (setDataCallback) setDataCallback(items);
        if (setTotalRowsCallback) setTotalRowsCallback(total);

    } catch (error) {
        handleApiError(error, 'Veriler alınırken bir hata oluştu.');
        if (setDataCallback) setDataCallback([]);
        if (setTotalRowsCallback) setTotalRowsCallback(0);
    }
};

export const fetchFormData = async ({
    apiEndpoint,
    page,
    pageSize,
    search,
    ...extraParams
}) => {
    try {
        const params = { page, pageSize, search };

        Object.keys(extraParams).forEach(key => {
            if (extraParams[key] !== null && extraParams[key] !== undefined) {
                params[key] = extraParams[key];
            }
        });

        const response = await apiClient.get(apiEndpoint, {
            params: params,
        });

        if (response.data) {
            return extractItemsFromResponse(response.data);
        } else {
            toast.error('Veri alınırken boş yanıt alındı.');
            return null;
        }
    } catch (error) {
        handleApiError(error, 'Veriler alınırken bir hata oluştu.');
        return null;
    }
};

export const postData = async ({ apiEndpoint, data }) => {
    try {
        const response = await apiClient.post(apiEndpoint, data);
        return response.data;
    } catch (error) {
        handleApiError(error, 'İşlem sırasında bir hata oluştu.');
        throw error;
    }
};

export const putData = async ({ apiEndpoint, data }) => {
    try {
        const response = await apiClient.put(apiEndpoint, data);
        return response.data;
    } catch (error) {
        handleApiError(error, 'İşlem sırasında bir hata oluştu.');
        throw error;
    }
};

export const handleAddModifyOperation = async ({
    apiEndpoint,
    selectedItem,
    mode,
    data,
    refreshDataCallback,
    componentName,
    isFormData = false,
    httpMethod = null
}) => {
    try {
        let response;

        if (mode === 'add') {
            response = await apiClient.post(apiEndpoint, data);
        } else if (mode === 'modify') {
            if (!selectedItem || selectedItem.id === undefined || selectedItem.id === null) {
                throw new Error("Güncelleme işlemi için geçerli bir öğe ID'si gereklidir.");
            }

            const method = httpMethod ? httpMethod.toLowerCase() : 'put';
            if (method === 'patch') {
                response = await apiClient.patch(`${apiEndpoint}/${selectedItem.id}`, data);
            } else {
                response = await apiClient.put(`${apiEndpoint}/${selectedItem.id}`, data);
            }
        } else {
            throw new Error(`Geçersiz işlem modu belirtildi: ${mode}`);
        }

        if (response.status >= 200 && response.status < 300) {
            const successMessage =
                mode === 'add'
                    ? `${componentName} başarıyla eklendi!`
                    : `${componentName} başarıyla güncellendi!`;
            toast.success(successMessage);

            if (refreshDataCallback) refreshDataCallback();
            return response.data || { success: true };
        } else {
            const errorMessage = `İşlem sırasında beklenmeyen bir durum oluştu (Status: ${response.status}).`;
            toast.error(errorMessage);
            throw new Error(errorMessage);
        }
    } catch (error) {
        const serverErrorMessage = error.response?.data?.message
            || error.response?.data?.title
            || (typeof error.response?.data === 'string' ? error.response.data : null)
            || (error.response?.status ? `Sunucu hatası (Kod: ${error.response.status})` : error.message);
        handleApiError(error, serverErrorMessage, {
            toastPrefix: `${componentName} işleminde hata: `
        });
        throw error;
    }
};
